import compass from '../openapi_compass.txt';
import { RedocStandalone } from 'redoc';
import { DEPLOYMENT_ENVIRONMENT } from '../constants/index';

function CompassFull() {
  if(DEPLOYMENT_ENVIRONMENT == "internal") {
  return (
    <div className="CompassFull">
      <RedocStandalone spec={compass} />
    </div>
  );
  }else{
    return null;
  }
}

export default CompassFull;
